import { __rest } from "tslib";
export function removeViewLevelProperties(obj) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { viewLevels, requiredViewLevel } = obj, rest = __rest(obj, ["viewLevels", "requiredViewLevel"]);
    return rest;
}
export function removeViewLevelFromCell(cell) {
    return removeViewLevelProperties(Object.assign(Object.assign({}, cell), { rows: cell.rows.map((row) => removeViewLevelFromRow(row)) }));
}
export function removeViewLevelFromRow(row) {
    return removeViewLevelProperties(Object.assign(Object.assign({}, row), { cells: row.cells.map((row) => removeViewLevelFromCell(row)) }));
}
//# sourceMappingURL=removeViewLevelProperties.js.map